import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, toHandlers as _toHandlers, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    persistent: "",
    "max-width": "600"
  }, {
    activator: _withCtx((scope) => [
      _renderSlot(_ctx.$slots, "activatorElement", _normalizeProps(_guardReactiveProps(scope)), () => [
        _createVNode(_component_v_btn, _mergeProps({
          color: "primary",
          text: _ctx.$t('components.confirmDialog.activator')
        }, _toHandlers(scope.on), {
          onClick: _ctx.open,
          textContent: _toDisplayString(_ctx.$t('components.confirmDialog.activator'))
        }), null, 16, ["text", "onClick", "textContent"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_FocusLock, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, {
                class: "headline font-weight-bold mb-2",
                textContent: _toDisplayString(_ctx.$t(_ctx.title))
              }, null, 8, ["textContent"]),
              _createVNode(_component_v_card_text, {
                textContent: _toDisplayString(_ctx.$t(_ctx.text))
              }, null, 8, ["textContent"]),
              _createVNode(_component_v_card_actions, { class: "ml-4 mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    ref: "submitButton",
                    color: "primary",
                    class: "modalbutton mb-3",
                    variant: "flat",
                    onClick: _ctx.confirm,
                    textContent: _toDisplayString(_ctx.$t('components.confirmdialog.confirm'))
                  }, null, 8, ["onClick", "textContent"]),
                  _createVNode(_component_v_btn, {
                    class: "modalbutton mb-3",
                    variant: "flat",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false)),
                    textContent: _toDisplayString(_ctx.$t('components.confirmdialog.cancel'))
                  }, null, 8, ["textContent"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["modelValue"]))
}